<template>
  <div id="prodRegist" ref="stickyParent" class="container" :class="{ reverse: reserveReverse }">
    <div class="infoBox">
      <router-view></router-view>
      <!-- <CustomerInfo v-if="showForm" />
      <ProductDetailDesc v-else :productItem="productItem" /> -->
    </div>
    <div class="selBox" data-v-sticky-container>
      <div v-if="isSticky" v-sticky="stickyOpt" ref="sticky">
        <ProductTicket />
      </div>
      <div v-else v-sticky="stickyOpt">
        <ProductTicket />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import VueStickyDirective from '@renatodeleao/vue-sticky-directive';
import ProductDetailDesc from '@/components/product/detail/ProductDetailDesc';
import ProductTicket from '@/components/product/detail/ProductTicket.vue';
import CustomerInfo from '@/components/product/detail/CustomerInfo.vue';

export default {
  name: 'ProductDetail',
  components: {
    ProductDetailDesc,
    ProductTicket: ProductTicket,
    CustomerInfo: CustomerInfo,
  },
  directives: { sticky: VueStickyDirective },
  data() {
    return {
      productId: null,
      isSticky: true,
      stickyOpt: {
        containerSelector: '.selBox',
        topSpacing: 20,
        bottomSpacing: 20,
        resizeSensor: true,
      },
      ro: null,
      stikcyHeight: 'inherit',
    };
  },
  computed: {
    ...mapState({ isLoggedIn: (state) => state.ui.isLoggedIn }),
    date() {
      return this.$store.state.reserve.ticket.date;
    },
    mrktnScheSeqNo() {
      return this.$store.state.reserve.ticket.mrktnScheSeqNo;
    },
    reserveReverse() {
      return !(this.$route.name === 'pcntInfo' || this.$route.name === 'groupInfo');
    },
    /* 시작, 종료일 */
    d() {
      return this.$route.query.d || '';
    },
    t() {
      return this.$route.query.t || '';
    },
  },
  watch: {},
  methods: {
    ...mapActions('reserve', ['resetReserveInfo', 'getProduct', 'getProductSchedule']),
    dateWatcher(to) {
      //this.$router.replace({ hash: to });
      this.getProductSchedule({
        id: this.productId,
        pgDiv: this.pgDiv,
        dt: to,
        seq: this.mrktnScheSeqNo > 0 ? this.mrktnScheSeqNo : null,
        d: this.d,
        t: this.t,
      });
    },
    mrktnScheSeqNoWatcher(to) {
      this.getProductSchedule({ id: this.productId, pgDiv: this.pgDiv, dt: this.date, seq: to, d: this.d, t: this.t });
    },
    handleResize() {
      const width = window.innerWidth;
      //this.height = window.innerHeight;
      this.isSticky = width > 820;
    },
    parentResize() {
      this.$refs.sticky?._stickySidebar.updateSticky();
    },
  },
  created() {
    this.productId = parseInt(this.$route.params.id);
    this.resetReserveInfo();
  },
  mounted: function () {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
    let dt = ''; //(this.$route.hash || '').replace('#', '');
    this.getProduct({ id: this.productId, pgDiv: this.pgDiv, dt, d: this.d, t: this.t })
      .then((opt) => {
        this.$watch('date', this.dateWatcher);
        if (opt.bExphRequest) {
          this.$watch('mrktnScheSeqNo', this.mrktnScheSeqNoWatcher);
        }
        if (this.$route.query.d) {
          if (!this.isLoggedIn) {
            customConfirm('로그인이 필요한 서비스 입니다. 로그인 하시겠습니까?', (confirm) => {
              if (confirm) {
                let domain = process.env.VUE_APP_API_DOMAIN;
                location.href = domain + '/login.do?menuId=109';
              } else {
                window.location.href = 'https://www.koreajobworld.or.kr';
              }
            });
          } else {
            alert(
              '이 상품은 전달받은 url로만 접근 가능한 상품입니다. \n다회차 예약을 하시려면 한 회차씩 체험 바구니에 담고 모든 회차를 담으신 후 체험바구니로 이동하여 예약을 진행해 주세요.',
            );
          }
        }
      })
      .catch((err) => {
        const data = err.response?.data;
        if (data?.success === false) {
          alert(data.apiError.message);
          this.$router.go(-1);
        }
      });
    this.ro = new ResizeObserver(this.parentResize);
    this.ro.observe(this.$refs.stickyParent);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);

    if (this.ro) {
      this.ro.unobserve(this.$refs.stickyParent);
    }
  },
};
</script>

<style lang="scss" scoped>
// .reverse {
//   flex-direction: row-reverse;
// }
</style>
